// Single source of truth for role-based access. Used now by the Role View Switcher,
// and ready to attach to real per-user accounts later (same keys enforced server-side).
export const ROLES = [
  {
    key: "owner", label: "Owner / Admin",
    blurb: "Full company overview — revenue, pipeline, jobs, invoices, memberships and warranty exposure.",
    sections: "*",
    widgets: ["revenue", "open_proposals", "booked_jobs", "outstanding_invoices", "memberships", "warranty", "new_leads"],
    quick: [{ label: "Requests", to: "leads" }, { label: "Dispatch", to: "dispatch" }, { label: "Launch Select", to: "launch-select" }, { label: "Invoices", to: "invoices" }],
  },
  {
    key: "csr", label: "CSR / Office",
    blurb: "New leads, communications, follow-ups, and upcoming appointments that need attention.",
    sections: ["overview", "leads", "calendar", "customers", "forms", "reviews", "promotions", "pricebook"],
    widgets: ["new_leads", "followups_due", "upcoming_appointments", "unscheduled_jobs"],
    quick: [{ label: "View Requests", to: "leads" }, { label: "Calendar", to: "calendar" }, { label: "Customers", to: "customers" }],
  },
  {
    key: "dispatcher", label: "Dispatcher",
    blurb: "Live schedule, technician board, job progress and unscheduled work.",
    sections: ["overview", "dispatch", "calendar", "field-service", "leads", "customers", "pricebook", "my-jobs"],
    widgets: ["jobs_today", "unscheduled_jobs", "booked_jobs", "upcoming_appointments"],
    quick: [{ label: "Open Dispatch Board", to: "dispatch" }, { label: "Calendar", to: "calendar" }, { label: "Field Service", to: "field-service" }],
  },
  {
    key: "technician", label: "Service Technician",
    blurb: "Today's jobs, customer history, and the forms you need in the field.",
    sections: ["overview", "calendar", "field-service", "customers", "forms", "pricebook", "my-jobs"],
    widgets: ["jobs_today", "upcoming_appointments"],
    quick: [{ label: "Today's Jobs", to: "field-service" }, { label: "Customers", to: "customers" }, { label: "Forms", to: "forms" }],
  },
  {
    key: "installer", label: "Installer / Install Mgr",
    blurb: "Upcoming installs, equipment, forms/checklists, and warranty registration.",
    sections: ["overview", "calendar", "field-service", "customers", "forms", "equipment", "warranty", "pricebook", "my-jobs", "equipment-hub"],
    widgets: ["booked_jobs", "upcoming_appointments", "warranty"],
    quick: [{ label: "Field Service", to: "field-service" }, { label: "Equipment", to: "equipment" }, { label: "Warranty", to: "warranty" }],
  },
  {
    key: "comfort-advisor", label: "Comfort Advisor / Sales",
    blurb: "Assigned opportunities, Good/Better/Best proposals, pipeline and follow-ups.",
    sections: ["overview", "leads", "customers", "launch-select", "selling-comfort", "load-calc", "forms", "membership", "comfort-club", "pricebook", "equipment-hub"],
    widgets: ["open_proposals", "new_leads", "memberships", "followups_due"],
    quick: [{ label: "Launch Select", to: "launch-select" }, { label: "Requests", to: "leads" }, { label: "Customers", to: "customers" }],
  },
];

export const DEFAULT_ROLE = "owner";
export const roleFor = (k) => ROLES.find((r) => r.key === k) || ROLES[0];
export const canSee = (role, key) => role.sections === "*" || role.sections.includes(key);